export default __webpack_public_path__ + "static/media/live-music.f63b4322.png";